import { ConvertBoxDataType } from '../convertBox.index';
export interface __BuyPaymentMethodProps {
    onSubmit: (e: ConvertBoxDataType) => void;
    onBack: () => void;
    data?: ConvertBoxDataType;
}

export enum __BuyPaymentMethodsEnum {
    Gateway,
    Wallet,
    Other,
}
